module.exports = __webpack_public_path__ + "static/media/GreyPenguin.459d26f5.png";